import React from 'react';
import { highlightText } from '@/utils/highlightText';

type SectionSubtitleProps = {
  subtitle: string;
  mt?: number;
  highlights?: string[];
};

export const SectionSubtitle = ({
  subtitle,
  mt = 12,
  highlights,
}: SectionSubtitleProps) => {
  return (
    <p
      className={`font-base text-2xl text-secondary-500 dark:text-lightBlue-200 mt-${mt} w-[100%] leading-normal xxs:max-md:w-full xxs:max-md:text-2xl`}
    >
      {highlightText(subtitle, highlights)}
    </p>
  );
};
